export const environment = {
    production: true,
    //discrepany api url
    baseApiUrl: 'https://dtechpubdiscrepancyapi.honeywell.com/api/',
    timeout: 600,
    redirectCallBackUrl: 'https://dtechpubdiscrepancy.honeywell.com/callback',
    clientId: 'Client_bkwi8946qe4t',
    authUrl: 'https://qauthn.honeywell.com/as/authorization.oauth2',  // OAuth Url
    apiKey: 'Q2xpZW50X2Jrd2k4OTQ2cWU0dDp4KXVsLTAyMWVocDZ4I2hz',
    // Aero Space Url
    redirectAeroHomePage: 'https://devaerotechpubs.reactapp.honeywell.com/',
    technicalFAQ: 'https://dpublish-aerospacebt.aws.aem.honeywell.com/us/en/support-and-resources/knowledge-and-training/technical-support',
    privPolicy: 'https://dpublish-hon.aws.aem.honeywell.com/us/en/privacy-statement',
    aeroHomeUrl: 'https://aerospace.honeywell.com/',
    licensed: true,
    aeroTokenProp: '2261-token',
    ssoUrl: 'https://dpublish-aerospacebt.aws.aem.honeywell.com/us/en/redirects/sso/technical-publications'
};